import React from 'react';
import { Link } from '@amzn/awsui-components-react';
import { renderStatusField } from '../CommonWidgetRenders';
import {renderNewLine } from '../DetailPage/AuditHistoryConfig'

export const wfHrefLink = (wfId) => {
  return "/detail/" + wfId;
}

export const onFollowHandler = (event,history) =>{
    if (!event.detail.external) {
      event.preventDefault();
      const href = event.detail.href      
      history.push(href)
    }
}

export const columnDefinitions = (history) => {
  return [
    {
      id: 'id',
      header: 'Workflow ID',
      cell: item => (
        <div>
          <Link
            href={wfHrefLink(item.id)}
            onFollow={(e) => {
              if (!e.detail.external) {
                e.preventDefault();
                const href = e.detail.href
                history.push(href)
              }
            }}>
            {item.id}
          </Link>
        </div>
      ),
    },
    {
      id: 'state',
      header: 'Workflow State',
      cell: item => renderStatusField(item.state)
    },
    // Currently workflow name 1:1 maps to workflow type, which makes it redundant.
    // In the future this could possibly be implemented as execution name.
    // {
    //   id: 'workflowName',
    //   cell: item => item.workflowName,
    //   header: 'Workflow Name'
    // },
    {
      id: 'assignedGroups',
      cell: item => renderNewLine(item.assignedGroups.replaceAll(",", ", ")),
      header: 'Assigned Group(s): Pending Time'
    },
    {
      id: 'requester',
      cell: item => item.requester,
      header: 'Requester'
    },
    {
      id: 'workflowType',
      cell: item => item.workflowType,
      header: 'Workflow Type'
    },
    {
      id: 'createdTime',
      header: 'Created Time (UTC+8)',
      cell: item => item.createdTime
    }
  ];
}

export const getColumnWithAdditionalHeader = (additionalTitles, type, history) => {
  let baseColumnDefs = columnDefinitions(history);
  
  //AssignedToMe page will not show additionalTitles columns
  if(type === "AssignedToMe") {
    return baseColumnDefs
  }
  
  //CasesByType page will show additionalTitles columns
  let additionalTitlesList = [];
  additionalTitles.forEach(header => {
      additionalTitlesList.push({
        id: header,
        cell: item => item.additionalMap[header],
        header: header
      })
    })
  
  // 将additionalTitlesList插入到Workflow State列后面
  // 找到Workflow State列的索引（id为'state'的列）
  const stateColumnIndex = baseColumnDefs.findIndex(col => col.id === 'state');
  
  if (stateColumnIndex !== -1) {
    // 将additional列插入到state列后面
    const beforeState = baseColumnDefs.slice(0, stateColumnIndex + 1);
    const afterState = baseColumnDefs.slice(stateColumnIndex + 1);
    return [...beforeState, ...additionalTitlesList, ...afterState];
  } else {
    // 如果没找到state列，则按原来的方式追加到最后
    return [...baseColumnDefs, ...additionalTitlesList];
  }
}
